import {useQuery} from "react-query";
import {http} from "../../../../../services/api/restApiClient";
import {WorkflowTriggerModel} from "../types";

type Params = {
  facilityId: string;
};

export const useWorkflowTriggersQuery = ({facilityId}: Params) =>
  useQuery(
    ["workflowTriggers", facilityId],
    async ({queryKey: [_, facilityId]}) => {
      const {data} = await http.get<ReadonlyArray<WorkflowTriggerModel>>(
        `/facilities/${facilityId}/workflow-triggers`,
      );
      return data;
    },
    {
      cacheTime: 0,
    },
  );
